import * as React from 'react'
import { Image, Text, View } from 'react-native'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import images from '../../assets/images'
import { TabCustomer, TabFinance, TabHome, TabProcess, TabTeam, TabBar } from '../components/index'
const Tab = createBottomTabNavigator()

export default React.memo(function Home() {
    return (
        <View style={{ flex: 1 }}>
            <Tab.Navigator tabBar={props => <TabBar {...props} />} initialRouteName='home'>
                <Tab.Screen
                    name="home"
                    component={TabHome}
                    options={{
                        tabBarLabel: 'Home',
                        tabBarImage: images.icons.tab_home,
                    }} />
                <Tab.Screen
                    name="finance"
                    component={TabFinance}
                    options={{
                        tabBarLabel: 'Doanh thu',
                        tabBarImage: images.icons.tab_finance,
                    }} />
                <Tab.Screen
                    name="customer"
                    component={TabCustomer}
                    options={{
                        tabBarLabel: 'Khách hàng',
                        tabBarImage: images.icons.tab_customer,
                    }} />

                <Tab.Screen
                    name="process"
                    component={TabProcess}
                    options={{
                        tabBarLabel: 'Vận hành',
                        tabBarImage: images.icons.tab_process,
                    }} />
                {/* <Tab.Screen name="team" component={TabTeam}
                    options={{
                        tabBarLabel: 'Nhân sự',
                        tabBarImage: images.icons.tab_team,
                    }} /> */}
            </Tab.Navigator>
        </View>
    )
})